import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faLinkedinIn, faVimeoV } from '@fortawesome/free-brands-svg-icons';
import '../../assets/css/style1.css';
import { Link } from 'react-router-dom';
import Socialicon from '../../pages/PrivacyPolicy/Socialicon';
import logoImage from '../../assets/images/logo.webp';

const Navbar = () => {
  // Check if user is logged in
  const isLoggedIn = localStorage.getItem('user') !== null;
  const user = isLoggedIn ? JSON.parse(localStorage.getItem('user')) : null;

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <section className="header header--2">
      {/* Top Bar */}
      <div className="top_bar top--bar2 d-flex align-items-center bg-primary">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex topbar_content justify-content-between">
                 
                <div className="top_bar--info order-0 d-none d-lg-block align-self-center">
                  <ul style={{fontSize:'20px', marginRight: '0.5rem'}}>
                    <Socialicon />
                  </ul>
                </div>
                <p style={{color:'#fff', paddingTop:'15px'}}>support@startupbusinesspartners.com</p>
                <div className="top_bar--social">
<ul style={{ position: 'relative', listStyle: 'none' }}>
  {isLoggedIn ? (
    <>
      {user && (
        <li className="dropdown" style={{ position: 'relative' }}>
          <button
            className="nav-link dropdown-toggle"
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: '20px',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.currentTarget.nextSibling.classList.toggle('show');
            }}
          >
            {user.name || user.email}
          </button>

          {/* Dropdown menu */}
          <ul
            className="dropdown-menu"
            style={{
              position: 'absolute',
              right: 0,
              top: '100%',
              background: '#fff',
              listStyle: 'none',
              padding: '10px 0',
              margin: 0,
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              display: 'none',
              minWidth: '150px',
            }}
          >
            <li>
              <Link
                className="dropdown-item"
                to="/dashboard"
                style={{
                  display: 'block',
                  padding: '8px 16px',
                  color: '#000',
                  textDecoration: 'none',
                }}
                onClick={(e) => {
                  e.currentTarget.parentNode.parentNode.classList.remove('show');
                }}
              >
                Dashboard
              </Link>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={handleLogout}
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '8px 16px',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  color: '#000',
                  cursor: 'pointer',
                }}
              >
                Logout
              </button>
            </li>
          </ul>
        </li>
      )}
    </>
  ) : (
    <>
      <li>
        <Link className="nav-link" to="/login" style={{ fontSize: '20px' }}>
          Login
        </Link>
      </li>
      <li>
        <Link className="nav-link" to="/register" style={{ fontSize: '20px' }}>
          Register
        </Link>
      </li>
    </>
  )}
</ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Menu Area */}
      <div className="menu_area menu1">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light bg-light px-0">
            <a className="navbar-brand order-sm-1 order-1" href="/">
              <img src={logoImage} style={{ height:'50px' }} alt="Dashboard" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent2"
              aria-controls="navbarSupportedContent2"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="la la-bars"></span>
            </button>

            <div className="collapse navbar-collapse order-md-1" id="navbarSupportedContent2">
              <ul className="navbar-nav m-auto">
                <li className="nav-item active">
                  <Link className="nav-link" to="/">Home</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/about">About us</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/plan">Plan</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/video">Video</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/blog">Blog</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/faq">FAQ</Link>
                </li>
                {/* <li className="nav-item active">
                  <Link className="nav-link" to="/career">Career</Link>
                </li> */}
                <li className="nav-item active">
                  <Link className="nav-link" to="/contact">Contact</Link>
                </li>
           
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </section>
  );
};

export default Navbar;